var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-10 col-sm-10 grid_div",attrs:{"id":"grid_right_div"}},[_c('div',{attrs:{"id":"contentDiv"}},[_c('div',{staticClass:"body_content"},[_c('DashboardContentPC',{ref:"contentRef"})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34647e7a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard.vue
// module id = null
// module chunks = 